var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rating',{attrs:{"value":_vm.value,"increment":1,"border-width":5,"rounded-corners":true,"star-size":30,"padding":15,"show-rating":false,"inactive-color":"#FFF","active-color":"#4766FF","border-color":"#4766FF"},model:{value:(_vm.localRating),callback:function ($$v) {_vm.localRating=$$v},expression:"localRating"}})
}
var staticRenderFns = []

export { render, staticRenderFns }